module.exports = __webpack_public_path__ + "static/img/til120.4c31312.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til120.png
// module id = VZBc
// module chunks = 1